import { render, staticRenderFns } from "./SendVideo.vue?vue&type=template&id=7b19b90a&scoped=true&"
import script from "./SendVideo.vue?vue&type=script&lang=ts&"
export * from "./SendVideo.vue?vue&type=script&lang=ts&"
import style0 from "./SendVideo.vue?vue&type=style&index=0&id=7b19b90a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b19b90a",
  null
  
)

export default component.exports